import { render, staticRenderFns } from "./RecycleReview.html?vue&type=template&id=ad04cb96&scoped=true&external"
import script from "./RecycleReview.js?vue&type=script&lang=js&external"
export * from "./RecycleReview.js?vue&type=script&lang=js&external"
import style0 from "./RecycleReview.vue?vue&type=style&index=0&id=ad04cb96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad04cb96",
  null
  
)

export default component.exports